import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import { useLayoutContext } from '@/context/LayoutContext';
import { StatusRowType } from '@/commonTypes';

/** One status line (points, transit, insurance…) with a left accent bar. */
export function StatusRow({
  row,
  compact,
  index,
}: {
  row: StatusRowType;
  compact?: boolean;
  index: number;
}) {
  const { rowPaletColors } = useLayoutContext();

  const palette = rowPaletColors[index % rowPaletColors.length];

  const accent = row?.accent ?? palette.accent;
  const bg = row?.bg ?? palette.bg;
  const valColor = row?.valColor ?? palette.valColor;
  return (
    <div className={styles.row} data-compact={compact} style={{ borderInlineStartColor: accent }}>
      <span className={styles.icon} style={{ background: bg, color: accent }}>
        <MainIcons.flashIcon fill={accent} />
      </span>

      <div className={`${styles.keyValue}`}>
        <div className={styles.text}>
          <div className={styles.label}>{row?.label}</div>
          {row?.sub && !compact && <div className={styles.sub}>{row?.sub}</div>}
        </div>

        <span className={styles.value} style={{ color: valColor }}>
          {row?.value}
        </span>
      </div>
    </div>
  );
}
